export enum FileFolderAction {
  Create = 'Create',
  MoveFolder = 'MoveFolder',
  MoveFile = 'MoveFile',
  Delete = 'Delete',
  UpdateFolder = 'UpdateFolder',
  UpdateFiles = 'UpdateFiles',
  ShareWithCustomer = 'ShareWithCustomer',
  WithdrawShareWithCustomer = 'WithdrawShareWithCustomer',
  View = 'View',
}
